import { useState } from "react"
import { getToken } from "../services/Token"
import Payroll from "./Payroll"
import PayRollTable from "./PayRollTable"
import { Box, Button } from "@mui/material"

const PayrollDashboard = ()=>{
    const role = getToken("roles") === "ADMIN"
    const [selectedTab, setSelectedTab] = useState("payroll")
    const tabs = [
        {
          id: "payroll",
          name: "Payroll Process",
          content: <Payroll/>
        },
        {
          id: "dashboard",
          name: "Dashboard",
          content: <PayRollTable/>,
        },
      ];
    return (
        <>
        {
            role && <Box className="flex justify-center" sx={{ pt: 6 }}>
            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              {tabs.map((tab) => (
                <Button
                  key={tab}
                  variant={selectedTab === tab?.id ? "contained" : "text"}
                  onClick={() => setSelectedTab(tab?.id)}
                  sx={{
                    textTransform: "none",
                    minWidth: 80,
                    backgroundColor:
                      selectedTab === tab?.id ? "#2196F3" : "transparent",
                    color: selectedTab === tab?.id ? "white" : "#666",
                    border: "1px solid #2196F3",
                  }}
                >
                  {tab?.name}
                </Button>
              ))}
            </Box>
          </Box>
        }
        {
            selectedTab === "payroll" ? <Payroll/> : <PayRollTable/>
        }
        </>
    )
}

export default PayrollDashboard